(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-body"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mjtArticleFaqMounted) return;
    window.__mjtArticleFaqMounted = true;

    function hydrateFaq() {
      var faqs = document.querySelectorAll('.mjt-faq [itemprop="mainEntity"]');
      faqs.forEach(function (q) {
        if (q.dataset.hydrated === 'true') return;
        var name = q.querySelector('[itemprop="name"]');
        var answer = q.querySelector('[itemprop="acceptedAnswer"]');
        if (!name || !answer) return;
        if (q.querySelector('details')) {
          q.dataset.hydrated = 'true';
          return;
        }

        var details = document.createElement('details');
        var summary = document.createElement('summary');
        summary.appendChild(name.cloneNode(true));
        var toggle = document.createElement('span');
        toggle.className = 'mjt-faq__toggle';
        toggle.setAttribute('aria-hidden', 'true');
        toggle.textContent = '+';
        summary.appendChild(toggle);
        details.appendChild(summary);

        var answerClone = answer.cloneNode(true);
        details.appendChild(answerClone);

        q.innerHTML = '';
        q.appendChild(details);
        q.dataset.hydrated = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrateFaq);
    } else {
      hydrateFaq();
    }

    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(hydrateFaq);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-progress"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mjtArticleProgressMounted) return;
    window.__mjtArticleProgressMounted = true;

    function mount() {
      var bar = document.querySelector('[data-article-progress]');
      if (!bar) return;

      var fill = bar.querySelector('.article-progress__fill');
      var selector = bar.getAttribute('data-progress-target') || '.main-article';
      var target = document.querySelector(selector);
      if (!target || !fill) return;

      var ticking = false;
      var visible = false;

      function setProgress(value) {
        var clamped = Math.max(0, Math.min(1, value));
        fill.style.setProperty('--progress', clamped.toFixed(4));
      }

      function update() {
        ticking = false;
        var rect = target.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        var totalScrollable = rect.height - viewportH;
        if (totalScrollable <= 0) {
          setProgress(rect.bottom <= viewportH ? 1 : 0);
          return;
        }
        var scrolled = -rect.top;
        setProgress(scrolled / totalScrollable);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          bar.classList.toggle('is-active', visible);
          if (visible) update();
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

      observer.observe(target);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount);
    } else {
      mount();
    }

    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(mount);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-toc"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mjtArticleTocMounted) return;
    window.__mjtArticleTocMounted = true;

    function slugify(text) {
      return (text || '')
        .toString()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }

    function build() {
      var nav = document.querySelector('[data-article-toc]');
      if (!nav) return;
      var list = nav.querySelector('[data-toc-list]');
      if (!list) return;
      var prose = document.querySelector('.article-prose');
      if (!prose) {
        nav.style.display = 'none';
        return;
      }

      var headings = prose.querySelectorAll('h2, h3');
      var entries = [];
      var usedSlugs = {};

      headings.forEach(function (h) {
        var inFaq = h.closest('.mjt-faq');
        var inTakeaways = h.closest('.mjt-key-takeaways');
        var inCallout = h.closest('.mjt-callout');
        var inSources = h.closest('.mjt-sources');
        var inProductLink = h.closest('.mjt-product-link');
        var inAuthorBio = h.closest('.mjt-author-bio');
        if (inFaq || inTakeaways || inCallout || inSources || inProductLink || inAuthorBio) return;

        var text = h.textContent.trim();
        if (!text) return;

        var slug = slugify(text);
        if (!slug) return;
        if (usedSlugs[slug]) {
          usedSlugs[slug] += 1;
          slug = slug + '-' + usedSlugs[slug];
        } else {
          usedSlugs[slug] = 1;
        }
        if (!h.id) h.id = slug;
        entries.push({ id: h.id, text: text, level: h.tagName === 'H3' ? 3 : 2, el: h });
      });

      if (entries.length === 0) {
        nav.style.display = 'none';
        return;
      }

      list.innerHTML = '';
      entries.forEach(function (entry) {
        var li = document.createElement('li');
        if (entry.level === 3) li.className = 'article-toc__sub';
        var a = document.createElement('a');
        a.href = '#' + entry.id;
        a.textContent = entry.text;
        a.dataset.tocLink = entry.id;
        li.appendChild(a);
        list.appendChild(li);
      });

      var links = list.querySelectorAll('a[data-toc-link]');
      var byId = {};
      links.forEach(function (a) { byId[a.dataset.tocLink] = a; });

      var observer = new IntersectionObserver(function (records) {
        records.forEach(function (record) {
          var id = record.target.id;
          var link = byId[id];
          if (!link) return;
          if (record.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

      entries.forEach(function (entry) { observer.observe(entry.el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    } else {
      build();
    }

    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(build);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-submit"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.KlaviyoSubmit) return;

    var BASE = 'https://a.klaviyo.com/client/';
    var REVISION = '2024-10-15';

    function post(path, publicKey, payload) {
      return fetch(BASE + path + '?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': REVISION
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (response.status === 200 || response.status === 201 || response.status === 202) {
          return { ok: true };
        }
        return response.json().then(function (data) {
          var msg = (data && data.errors && data.errors[0] && data.errors[0].detail) || 'Submission failed.';
          var err = new Error(msg);
          err.status = response.status;
          err.body = data;
          throw err;
        }, function () {
          var err = new Error('Submission failed.');
          err.status = response.status;
          throw err;
        });
      });
    }

    function subscribe(opts) {
      opts = opts || {};
      var publicKey = opts.publicKey;
      var email = opts.email;

      if (!publicKey) return Promise.reject(new Error('Missing Klaviyo public key.'));
      if (!email) return Promise.reject(new Error('Missing email.'));

      var profileAttrs = { email: email };
      var props = {};
      if (opts.signupSource) props.signup_source = opts.signupSource;
      if (opts.properties) {
        Object.keys(opts.properties).forEach(function (k) { props[k] = opts.properties[k]; });
      }
      if (Object.keys(props).length > 0) profileAttrs.properties = props;

      if (opts.listId) {
        return post('subscriptions/', publicKey, {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: opts.customSource || opts.signupSource || 'storefront',
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: {
              list: { data: { type: 'list', id: opts.listId } }
            }
          }
        });
      }

      return post('profiles/', publicKey, {
        data: { type: 'profile', attributes: profileAttrs }
      });
    }

    function track(opts) {
      opts = opts || {};
      var publicKey = opts.publicKey;
      var metric = opts.metric;

      if (!publicKey) return Promise.reject(new Error('Missing Klaviyo public key.'));
      if (!metric) return Promise.reject(new Error('Missing metric name.'));

      var attrs = {
        metric: { data: { type: 'metric', attributes: { name: metric } } },
        properties: opts.properties || {}
      };

      if (opts.profile) {
        attrs.profile = { data: { type: 'profile', attributes: opts.profile } };
      }

      return post('events/', publicKey, {
        data: { type: 'event', attributes: attrs }
      });
    }

    window.KlaviyoSubmit = { subscribe: subscribe, track: track };
  })();
  } catch(e) { console.error(e); }
})();

})();
